var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_1379_10259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 16.4062C15.7767 16.4062 16.4062 15.7767 16.4062 15C16.4062 14.2233 15.7767 13.5938 15 13.5938C14.2233 13.5938 13.5938 14.2233 13.5938 15C13.5938 15.7767 14.2233 16.4062 15 16.4062Z",
    fill: "#374151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 8.90625C15.7767 8.90625 16.4062 8.27665 16.4062 7.5C16.4062 6.72335 15.7767 6.09375 15 6.09375C14.2233 6.09375 13.5938 6.72335 13.5938 7.5C13.5938 8.27665 14.2233 8.90625 15 8.90625Z",
    fill: "#374151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 23.9062C15.7767 23.9062 16.4062 23.2767 16.4062 22.5C16.4062 21.7233 15.7767 21.0938 15 21.0938C14.2233 21.0938 13.5938 21.7233 13.5938 22.5C13.5938 23.2767 14.2233 23.9062 15 23.9062Z",
    fill: "#374151"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1379_10259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/moreIcon.9301498beeb3a280feec6846730fd2c8.svg";
export { ForwardRef as ReactComponent };